import React from 'react';
import { View, Image } from 'react-native';
import { withRouter } from "react-router-dom";

import {Card, Header, Button, Spacing, InformationDialogue} from "../../../components";
import Colors from "../../../constants/Colors";

const JourneyElementsAccessCard = (props) => {

    return (
        <Card containerStyle={{  marginLeft: 20, marginRight: 20, marginBottom: 8, padding: 12, justifyContent: 'flex-start', alignItems: 'center' }}>

            <Header
                headerText={"Treinamento"}
                propsTextStyle={{ fontSize: 22, color: 'white' }}
                containerPropsStyle={{ backgroundColor: Colors.cardBackgroundColor }}
            />
            <Spacing height={12} />
            <Image
                source={require('../../../imageImports/journeyTimeline.png')}
                style={{  height: 120, width: '100%', borderRadius: 8  }}
            />
            <Spacing height={12} />
            <Button
                text={'Acessar'}
                onPress={() => props.history.push(`/journey/timeline?journeyId=${props.journeyId}`)}
                // onPress={() => props.navigation.navigate('JourneyElements', { journeyId: props.journeyId })}
                containerPropsStyle={{ height: 30, borderRadius: 8, backgroundColor: Colors.cardButtonBackground }}
                textPropsStyle={{ fontSize: 16, color: Colors.cardButtonFontColor }}
            />
        </Card>
    )
}

export default withRouter(JourneyElementsAccessCard);
